<template>
  <tr>
    <td>{{ accountPermission }}</td>
  </tr>
</template>

<script>
export default {
  props: [
    'accountPermission'
  ]
}
</script>



// WEBPACK FOOTER //
// AccountPermissionsRow.vue?f7264184